import { render, staticRenderFns } from "./TransicionLogin.vue?vue&type=template&id=f15255ca&scoped=true"
import script from "./TransicionLogin.vue?vue&type=script&lang=js"
export * from "./TransicionLogin.vue?vue&type=script&lang=js"
import style0 from "./TransicionLogin.vue?vue&type=style&index=0&id=f15255ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15255ca",
  null
  
)

export default component.exports